import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { IS_PRODUCTION } from "./variables/config"

if (!window.i18n) {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: window.APP_LOCALE,
      fallbackLng: false,
      backend: {
        loadPath: "/api/translations?locale={{lng}}",
        requestOptions: {
          cache: "default",
          credentials: "include",
        },
      },
      load: "currentOnly",
      supportedLngs: ["ro", "ru", "uk", "en", "fr", "bg"],
      detection: {
        order: ["navigator"],
        caches: [],
      },
      debug: !IS_PRODUCTION,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
    })

  window.i18n = i18n
  window.dispatchEvent(new Event("i18n:ready"))
}

export default window.i18n
